import { AI_ENABLED } from "../features";

export type SystemPageKind = "update" | "ai";

/**
 * Страницы системного администратора — по адресу, без остальной системы
 * (SystemPage). Отдельно от неё: App узнаёт адрес сразу, а сама страница
 * грузится, только когда её открыли.
 */
export const SYSTEM_PAGES: { kind: SystemPageKind; href: string; title: string }[] = [
  { kind: "update", href: "/update", title: "Обновление системы" },
  // Сборка без ИИ (по умолчанию, features.ts) — без страницы помощника.
  ...(AI_ENABLED ? [{ kind: "ai" as const, href: "/ai", title: "ИИ-помощник" }] : []),
];

/** Адрес страницы системного администратора → какая это страница (или null). */
export function systemPageAt(pathname: string): SystemPageKind | null {
  const path = pathname.replace(/\/+$/, "");
  return SYSTEM_PAGES.find((p) => p.href === path)?.kind ?? null;
}
